import { motion } from "framer-motion";
import { GitBranch } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const SPANS = [
  "md:col-span-7", "md:col-span-5",
  "md:col-span-5", "md:col-span-7",
  "md:col-span-6", "md:col-span-6",
];

const CRYSTAL = "https://images.unsplash.com/photo-1546608135-e5de34abc308?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxnbG93aW5nJTIwcXVhcnR6JTIwY3J5c3RhbCUyMG1hY3JvfGVufDB8fHx8MTc4NDI1MjgzNnww&ixlib=rb-4.1.0&q=85";

export const Topics = ({ topics }) => (
  <section id="topics" className="relative py-28 md:py-36" data-testid="topics-section">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_80%_10%,rgba(0,240,255,0.06),transparent_45%)]" />
    <div className="section-shell relative">
      <SectionHeader
        index="02"
        overline="The Living Garden"
        title="Topics of Inquiry"
        description="Six interconnected fields that feed one another. Each is a living hub — pull one thread and the others move."
      />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        {topics.map((t, i) => (
          <Reveal key={t.id || t.name} delay={i * 0.05} className={SPANS[i % SPANS.length]}>
            <motion.div
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
              className="group relative h-full overflow-hidden rounded-xl glass-card p-8"
              data-testid={`topic-card-${i}`}
            >
              {i === 0 && (
                <div className="absolute -right-10 -top-10 h-40 w-40 opacity-20 transition-opacity duration-500 group-hover:opacity-40">
                  <img src={CRYSTAL} alt="" className="h-full w-full rounded-full object-cover blur-[1px]" />
                </div>
              )}
              <div className="relative flex h-full flex-col">
                <span className="mb-5 flex h-9 w-9 items-center justify-center rounded-full border border-plasma-teal/30 text-plasma-teal transition-shadow duration-500 group-hover:shadow-[0_0_20px_rgba(29,233,182,0.4)]">
                  <span className="h-1.5 w-1.5 rounded-full bg-plasma-teal" />
                </span>
                <h3 className="font-display text-2xl md:text-3xl font-light leading-tight text-white">
                  {t.name}
                </h3>
                <p className="mt-4 font-sans text-sm font-light leading-relaxed text-slate-400">
                  {t.description}
                </p>
                <div className="mt-auto flex items-center gap-2 pt-6 font-mono text-[10px] uppercase tracking-widest text-slate-500">
                  <GitBranch className="h-3.5 w-3.5 text-plasma-teal/60" strokeWidth={1.5} />
                  {t.relatedPaperSlugs?.length
                    ? `Linked to ${t.relatedPaperSlugs.length} paper${t.relatedPaperSlugs.length > 1 ? "s" : ""}`
                    : "Emerging inquiry"}
                </div>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
